module.exports = __webpack_public_path__ + "static/media/6TunasDouro.1df5e7db.jpg";